import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import Font from '@cred/react-font'
import { elementRender } from '@cred/react-analytics/events'
import styles from './styles.scss'

const getZipCodeErrorMessage = err => err
  && err.graphQLErrors
  && err.graphQLErrors[0] && err.graphQLErrors[0].fields
  && err.graphQLErrors[0].fields.zip_code && err.graphQLErrors[0].fields.zip_code[0]

const ErrorNoOffers = ({ error, trackSnowplowEvent }) => {
  const zipCodeErrorMessage = getZipCodeErrorMessage(error)
  useEffect(() => {
    trackSnowplowEvent(elementRender, {
      name: zipCodeErrorMessage ? 'Not supported state' : 'No offers',
      description: zipCodeErrorMessage ? 'Unfortunately, we don’t support this Zip code yet' : 'This could be because of technical issues or the information you input above. You may try again later, or check for personalized prequalified rates by clicking below.',
    })
  }, [])

  if (zipCodeErrorMessage) {
    return (
      <Font
        type="bodySmall"
        color="lighter"
        className={styles.errorMessage}
      >
        {zipCodeErrorMessage}
      </Font>
    )
  }

  return (
    <>
      <Font type="bodySmall" color="lighter">This could be because of technical issues or the information you input above.</Font>
      <Font type="bodySmall" color="lighter">You may try again later, or check for personalized prequalified rates by clicking below.</Font>
    </>
  )
}

ErrorNoOffers.propTypes = {
  error: PropTypes.object,
  trackSnowplowEvent: PropTypes.func.isRequired,
}

export default withSnowplowContexts(ErrorNoOffers)
